import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Schedule } from './types';

type GetScheduleResponse = {
  state: number;
  value: Schedule[];
};

export const getModificationHistory = async (
  codViaje: number
): Promise<Schedule[]> => {
  try {
    const res = await apiClient.post<GetScheduleResponse>(
      Endpoints.HistorialModificacionViajes,
      {
        codViaje,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
